
import { RootState } from '../../rootReducer';

const selectUpdatingPaymentMethod = (state: RootState): boolean => state.accounts.paymentMethod.loading;
const selectErrorUpdatingPaymentMethod = (state: RootState): boolean => state.accounts.paymentMethod.error;

export const selectors = {
  selectUpdatingPaymentMethod,
  selectErrorUpdatingPaymentMethod
};